"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".accountView__userDetails{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;font-size:16px;font-weight:600;color:#ff4081}.accountView__premiumIcon{width:40px;height:40px;margin-left:10px;background-image:url(/images/premium-icon.png);background-repeat:no-repeat;background-position:center;background-size:contain}.accountView .mat-button-base,.accountView .mat-list-item-content{width:100%}.accountView .mat-button-wrapper{display:flex;align-items:center;justify-content:space-between}"];
exports.styles = styles;
